<template>
  <TsColumn append-class="p-0 max-w-64" :data-testid="baseDataTestId + 'section'">
    <TsRow append-class="m-0 bg-primary border-none rounded-xl gap-2 items-center pl-1 pr-4 py-1 md:py-0">
      <TsImage width="76" height="89" :src="props.image" alt="brand-product" :data-testid="baseDataTestId + 'brand-product'" loading="lazy"/>
      <TsColumn append-class="p-0 items-center">
        <TsTypography append-class="text-white text-xs md:text-base" :data-testid="baseDataTestId + 'heading'"><div v-html="props.heading" /></TsTypography>
        <TsTypography append-class="text-white text-xl md:text-4xl" :data-testid="baseDataTestId + 'description'"><div v-html="props.description" /></TsTypography>
      </TsColumn>
    </TsRow>
  </TsColumn>
</template>

<script setup lang="ts">
  type Props = {
  image?: string;
  heading?: string;
  description?: string;
};

const props = withDefaults(defineProps<Props>(), {
  image: "/images/brandDealsProduct1.png",
  heading: "Check out",
  description: "Products"
});

const baseDataTestId = "card-checkout-";

</script>